import React, { useState } from 'react'
import { IconTrash } from '@tabler/icons-react'
import { uniqBy, flatten } from 'lodash'
import pluralize from 'pluralize'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { ModalActions } from '@/components/modals/ModalActions'
import { createDeleteConfirmationContent } from '@/views/PlaybookMapping/helpers'
import { Button } from '@/components/buttons/Button'

export const DeleteCampaignModal = ({ onDelete, campaigns = [], useIcon = true }) => {
  const [open, setOpen] = useState(false)
  const isSingle = campaigns.length === 1
  const allUnmatched = campaigns.every((c) => c.isUnmatched)
  const affectedScorecards = uniqBy(flatten(campaigns.map((c) => c.scorecard_configs || [])), 'id')
  const deleteFormContent = createDeleteConfirmationContent(campaigns, affectedScorecards)

  return (
    <>
      <Button
        basic
        small
        disabled={allUnmatched}
        disabledTooltip={`${isSingle ? 'This campaign' : 'These campaigns'} ${isSingle ? 'has' : 'have'} no mapping to delete`}
        tooltip="Delete Campaign"
        onClick={() => setOpen(true)}
        {...(useIcon
          ? { icon: <IconTrash />, square: true }
          : { children: `Delete ${pluralize('Campaign', campaigns.length)}`, critical: true })}
      />
      <BasicModal
        title={`Delete ${pluralize('Campaign', campaigns.length, true)}${isSingle ? ` "${campaigns[0].name}"` : ''}`}
        onClose={() => setOpen(false)}
        show={open}
        size="tiny"
      >
        {deleteFormContent}
        <ModalActions
          onClose={() => setOpen(false)}
          onSubmit={() => onDelete({ campaignUuids: campaigns.map((campaign) => campaign.uuid) })}
          isDelete
        />
      </BasicModal>
    </>
  )
}
